import { render, staticRenderFns } from "./getRejectDetail.vue?vue&type=template&id=6561af4d&lang=pug"
import script from "./getRejectDetail.vue?vue&type=script&lang=js"
export * from "./getRejectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports